/* Page to hold the Callsheet Link */
import React, { useEffect } from "react";
import btnStyles from "../styles/Button.module.css";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../styles/Scene.module.css";
import { useState } from "react";
import CopyLinkInfo from "../pages/callsheets2/info2/CopyLinkInfo";

export const CopyLink = () => {
  const [showInfo, setShowInfo] = useState(false);

  const [path, setPath] = useState("");

  useEffect(() => {
    /* Function to set the path */
    const pathone = window.location.href;
    setPath(pathone);
  }, []);

  return (
    <div>
    <Row >
    <Col md={{span: 10, offset: 1}} className={`pb-2 px-0 ${styles.WhiteForm}`}>
    {/* title */}
    <div className={`mt-0 mb-0 ${styles.SubTitle}`}>
      <h5 className={`pb-0 text-center ${styles.BoldTrack}`}>
    COPY CALLSHEET LINK{" "}
      </h5>
    </div>
      <Row>
        <Col xs={12}>
          <Button
            className={`float-right py-0 mt-1 ${btnStyles.Order} ${btnStyles.Button}`}
            onClick={() => setShowInfo((showInfo) => !showInfo)}
          >
            INFO
          </Button>
        </Col>
      </Row>
      {!showInfo ? "" : <CopyLinkInfo />}
        {/* path */}
        <Row className="mt-3 mb-3">
        <Col className={`${styles.Wid} text-center `}>
        <p className={`${styles.BoldScene}`}>Callsheet Link</p>
        <p>{path}</p>
        </Col>
        </Row>
        </Col>
    </Row>
    </div>
  );
};